/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Panel_Move_LeftInputs */



/**
* | output |
* | --- |
* | "Move panel left" |
*
* @param {Artifact_Panel_Move_LeftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_panel_move_left = /** @type {((inputs?: Artifact_Panel_Move_LeftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Panel_Move_LeftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Panel nach links verschieben")
	return /** @type {LocalizedString} */ ("Move panel left")
});